import React from 'react';
import { useAuthStore } from '../../store/authStore';
import {
  DashboardAdmin,
  DashboardDekan,
  DashboardObserver,
  DashboardPelapor,
  DashboardRektor,
  DashboardSekretaris,
  DashboardWarek,
} from '../../pages/dashboard';

const DASHBOARD_MAP: Record<string, React.FC> = {
  admin: DashboardAdmin,
  rektor: DashboardRektor,
  sekretaris: DashboardSekretaris,
  warek: DashboardWarek,
  dekan: DashboardDekan,
  observer: DashboardObserver,
  pelapor: DashboardPelapor,
};

const RoleBasedDashboard: React.FC = () => {
  const { user } = useAuthStore();

  // Ambil dashboard_type dari role user
  const dashboardType = user?.role?.dashboard_type || 'pelapor';

  // Cari komponen dashboard yang sesuai
  const DashboardComponent = DASHBOARD_MAP[dashboardType] || DashboardPelapor;

  return <DashboardComponent />;
};


export default RoleBasedDashboard;
